export enum EAdminEventsRoutes {
    ADMIN_EVENTS_CREATE = 'adminEventsCreate',
    ADMIN_EVENTS_DETAIL = 'adminEventsDetail',
    ADMIN_EVENTS_TABLE = 'adminEventsTable'
}
export const EAdminEventsRoutesValues = [
    EAdminEventsRoutes.ADMIN_EVENTS_CREATE,
    EAdminEventsRoutes.ADMIN_EVENTS_DETAIL,
    EAdminEventsRoutes.ADMIN_EVENTS_TABLE
]

export const ADMIN_STATS_ROUTE_NAME = 'stats'
